export default __webpack_public_path__ + "static/media/CMS_Service Request.ef588f4f.svg";